import { NavLink } from 'react-router-dom';

// Light white sidebar, navy nav items, bright-blue active state — per
// BRAND_TOKENS.md §4 ("white LEFT sidebar, not a dark rail") and the
// Figma reference screens (Dashboard.png).
const NAV_ITEMS = [
  { to: '/app', label: 'Overview', icon: '◈' },
  { to: '/app/briefings', label: 'Daily Briefings', icon: '📰' },
  { to: '/app/screener', label: 'Stock Screener', icon: '🔎' },
  { to: '/app/portfolio', label: 'Portfolio & Backtest', icon: '📊' },
  { to: '/app/backtest', label: 'Backtest Studio', icon: '🧪' },
  { to: '/app/research', label: 'Research Marketplace', icon: '💡' },
  { to: '/app/strategies', label: 'Strategy Marketplace', icon: '♻️' },
  { to: '/app/billing', label: 'Pricing & Billing', icon: '💳' },
];

export default function Sidebar({ mobileOpen, onClose }) {
  return (
    <aside className={`aq-sidebar ${mobileOpen ? 'aq-sidebar--open' : ''}`}>
      <div className="aq-sidebar-brand">
        <span className="aq-wordmark">
          Alpha<span className="aq-wordmark-accent">Qap</span>
        </span>
        <span className="aq-sidebar-cobrand">Qaptal × AlphaQuark</span>
      </div>

      <nav className="aq-sidebar-nav">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/app'}
            className={({ isActive }) => `aq-nav-item ${isActive ? 'aq-nav-item--active' : ''}`}
            onClick={onClose}
          >
            <span className="aq-nav-icon" aria-hidden="true">
              {item.icon}
            </span>
            {item.label}
          </NavLink>
        ))}
      </nav>

      <div className="aq-sidebar-footer">
        <span className="aq-sidebar-note">Technology layer only.</span>
        <span className="aq-sidebar-note aq-sidebar-note--dim">
          No advice · No custody · No execution
        </span>
      </div>
    </aside>
  );
}
